import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import './style.less';

export default class RidingKnow extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    
    componentDidMount() {

    }

    render() {
        return (
            <div className="RidingKnow">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}></i>}
                >帮助中心</NavBar>
                <div className="contentBox">
                    <div className="title">乘车须知</div>
                    <div className="first">
                        <div>一、乘客不得携带或者夹带交通运输部明文规定的<span className="colorRed">危险物品、禁运物品、超限物品</span>乘车。</div>
                        <div>二、凡有以下情况之一者不准乘车：</div>
                        <div className="textIndent">1、不遵守汽车客运规章而不听劝告者；</div>
                        <div className="textIndent">2、精神失常无人护送或虽有人互送仍可能危及其他旅客安全者；</div>
                        <div className="textIndent">3、恶性传染病患者。</div>
                        <div className="textIndent">4、危害公共交通安全的其他情形。</div>
                        <div>三、乘车时不得将头、手、身伸出车外，不准翻越车窗，车未停稳不准上下，行驶中严禁开启车门。</div>
                        <div>四、乘客在车辆行驶途中应该严格按照驾驶员的正确规范要求指示乘车，遇到紧急情况时应听从驾驶员的安全指示操作，确保乘客的人身财产安全。</div>
                        <div className="footer">尊敬的旅客：感谢您乘坐，祝您旅途愉快，安全到达目的地！欢迎下次光临。</div>
                    </div>
                   
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Member/HelpCenter/RidingKnow/index.js